import axios  from "axios"

export default {
    async getGenos(dataOptions,search) {
        var url = `animal/genotype-performance?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
            if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async loadbreed() {
        return await axios.get('option/animal/breeds')
            .then((data) =>data.data )
            .catch( error => Promise.reject(error));
    },
    async registerGeno(data) {
        return await axios.post('animal/genotype-performance', data)
            .then(result => result.data)
            .catch( error => Promise.reject(error));
    },
    async getGeno(id) {
        console.log("id",id)
        var url = `animal/genotype-performance/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async UpdateGeno(data) {
        var url = `animal/genotype-performance`
        return await axios.put(url, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error))
    },
}